/**
 * Zod 4 probes `new Function('')` the first time it parses an object, to
 * decide whether it may JIT-compile parsers. Under the SPA's CSP (no
 * 'unsafe-eval', build/csp.ts) the probe is refused and reported as a CSP
 * violation on every page load. Telling zod up front to stay jitless skips
 * the probe; parsing behaves the same. Imported first in main.tsx.
 */
import { config } from 'zod';

config({ jitless: true });
